import { defineStore } from 'pinia'
import BabyRepository from '~~/repositories/BabyRepository.js'

export const useBabiesStore = defineStore('babies', {
    state: () => ({
        babies: [],
        currentBabyUuid: null,
        currentBabyRegistrationUuid: null
    }),

    actions: {
        fetchBabies () {
            return BabyRepository.index()
                .then((response) => {
                    this.babies = response.data
                    if ((!this.currentBabyUuid || !this.currentBabyRegistrationUuid) && this.babies?.length > 0) {
                        this.setCurrentBabyUuid(
                            this.babies[0].uuid,
                            this.babies[0].registrations?.[0]?.uuid
                        )
                    }
                })
                .catch((error) => {
                    console.error(error)
                })
        },

        setCurrentBabyUuid (babyUuid, registrationUuid) {
            this.currentBabyUuid = babyUuid
            this.currentBabyRegistrationUuid = registrationUuid
        },

        refreshCurrentBaby () {
            return this.fetchBabies()
        }
    },

    getters: {
        currentBaby () {
            return this.babies.find(baby => baby.uuid === this.currentBabyUuid)
        },
        currentRegistration () {
            return this.babies.find(baby => baby.uuid === this.currentBabyUuid)?.registrations?.find(registration => registration.uuid === this.currentBabyRegistrationUuid)
        }
    },

    persist: {
        pick: ['currentBabyUuid', 'currentBabyRegistrationUuid']
    }
})
